import React, { useState, useEffect } from "react";
import { Button, Card, CardBody } from "reactstrap";
import Breadcrumbs from "components/Breadcrumbs/breadcrumbs";
import TopHeader from "components/TopHeader/topHeader";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useHistory, useParams } from "react-router-dom";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import moment from "moment";
import cronTime from "cron-time-generator";
import cronParser from "cron-parser";
import { useCookies } from "react-cookie";
import Modal from "components/Modal/Modal";
import useApi from "../../../apiHooks/apiHooks";
import Swal from "sweetalert2";
import displayToast from "functions/displayToast";

export default function EditShop() {
    const [cookies, setCookie] = useCookies();
    const { id } = useParams();
    const { getShopDetails, getAllCompanies, deleteShop, editShop } = useApi();

    const getCompanyId = (company) => {
        if (!company) {
            return "";
        }
        return typeof company === "object" ? company._id || "" : company;
    };

    // Get Shop Details
    const [data, setData] = useState(null);
    const getDetails = async () => {
        let headers = {
            headers: {
                "auth-token": cookies.userToken,
            },
        };
        try {
            const response = await getShopDetails(headers);
            setData(response.data);
        } catch (err) {
            const error = err.response;
            console.log(`err`, error);
        }
    };

    // Get Companies
    const [companies, setCompanies] = useState(null);
    const getCompanies = async () => {
        let headers = {
            headers: {
                "auth-token": cookies.userToken,
            },
        };
        try {
            const response = await getAllCompanies(headers);
            setCompanies(response.data.companies);
        } catch (err) {
            const error = err.response;
            console.log(`err`, error);
        }
    };

    useEffect(() => {
        getDetails();
    }, []);

    useEffect(() => {
        if (data) {
            setInitialValues({
                shopLocation: data.location,
                companyName: getCompanyId(data.Company),
                pos_type: data.pos_type,
                schedule: data.schedule,
                pos_script: data.pos_script_name || data.pos_script || "",
                pos_script_name: data.pos_script_name || data.pos_script || "",
                notification_email: data.notification_email || "",
                is_email_notification_enabled:
                    data.is_email_notification_enabled || false,
                upload_url: data.upload_url,
                upload_username: data.upload_username,
                upload_password: data.upload_password,
            });
            getCompanies();
        }
    }, [data]);

    // Delete Shop
    const removeShop = async () => {
        let headers = {
            headers: {
                "auth-token": cookies.userToken,
            },
        };
        try {
            await deleteShop(headers);
            displayToast("success", "Shop deleted successfully");

            history.push("/admin/shops");
        } catch (err) {
            const error = err.response;
            displayToast("error", "An Error has occurred");
            console.log(`err`, error);
        }
    };

    // Time Picker
    const showSecond = false;
    const format = "h:mm a";
    // Formik
    const history = useHistory();
    const [initialValues, setInitialValues] = useState(null);
    // console.log(initialValues);

    const validationSchema = Yup.object({
        shopLocation: Yup.string().required("Shop Location is required"),
        companyName: Yup.string().required("Company Name is required"),
        pos_type: Yup.string()
            .oneOf(["VendHQ", "Shopify", "Others"], "Select a valid POS Type")
            .required("POS Type is required"),
        schedule: Yup.mixed().required("Schedule is required"),
        pos_script: Yup.mixed().required("POS Script is required"),
        upload_url: Yup.string().required("Upload URL is required"),
        upload_username: Yup.string().required("Upload Username is required"),
        upload_password: Yup.string().required("Upload Password is required"),
        notification_email: Yup.string()
            .email("Notification Email must be a valid email address")
            .when("is_email_notification_enabled", {
                is: true,
                then: Yup.string()
                    .email("Notification Email must be a valid email address")
                    .required("Notification Email is required"),
            }),
    });
    const onSubmit = (values) => {
        // console.log(`form`, values);
        handleSubmit(values);
    };

    const handleSubmit = async (data) => {
        let formData = new FormData();
        formData.append("location", data.shopLocation);
        formData.append("Company", data.companyName);
        formData.append("pos_script", data.pos_script);
        formData.append("upload_url", data.upload_url);
        formData.append("upload_username", data.upload_username);
        formData.append("upload_password", data.upload_password);
        formData.append("pos_type", data.pos_type);
        formData.append("schedule", data.schedule);
        formData.append("notification_email", data.notification_email || "");
        formData.append(
            "is_email_notification_enabled",
            data.is_email_notification_enabled
        );

        let headers = {
            headers: {
                "Content-Type": "multipart/form-data",
                "auth-token": cookies.userToken,
            },
        };
        try {
            await editShop(formData, headers);

            displayToast("success", "Shop edited successfully");

            history.push("/admin/shops");
        } catch (err) {
            const error = err.response;
            console.log(`err`, error);
            displayToast("error", "An Error has occurred");
        }
    };

    // Styles
    const styles = {
        input: { padding: "0.75rem", width: "70%" },
    };

    const getScheduleDefaultValue = (schedule) => {
        try {
            return schedule
                ? moment(cronParser.parseExpression(schedule).next().toString())
                : null;
        } catch (err) {
            return null;
        }
    };

    // Modal
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
    };
    return (
        <>
            {initialValues && (
                <div className="m-5">
                    <TopHeader title={initialValues.shopLocation} />
                    <Breadcrumbs
                        pageLink="/admin/shops"
                        pageName="Shops"
                        currentPageName={initialValues.shopLocation}
                    />
                    <Card className="my-5">
                        <CardBody>
                            <h3
                                className="mb-5 mt-3"
                                style={{ fontWeight: "700", marginLeft: "2em" }}
                            >
                                Update the following fields to edit shop data:
                            </h3>

                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={onSubmit}
                            >
                                {(formik) => (
                                    <Form
                                        style={{
                                            marginTop: "2em",
                                            marginLeft: "2em",
                                        }}
                                    >
                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Company:
                                            </label>
                                            <div className="col-sm-10">
                                                <Field
                                                    id="companyName"
                                                    name="companyName"
                                                    as="select"
                                                    className="form-control"
                                                    style={styles.input}
                                                >
                                                    {companies &&
                                                        companies.map(
                                                            (
                                                                company,
                                                                index
                                                            ) => (
                                                                <option
                                                                    value={
                                                                        company._id
                                                                    }
                                                                    key={index}
                                                                >
                                                                    {
                                                                        company.name
                                                                    }
                                                                </option>
                                                            )
                                                        )}
                                                </Field>
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="companyName"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Location:
                                            </label>
                                            <div className="col-sm-10">
                                                <Field
                                                    id="shopLocation"
                                                    name="shopLocation"
                                                    className="form-control"
                                                    placeholder="123 North St"
                                                    style={styles.input}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="shopLocation"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Upload URL:
                                            </label>
                                            <div className="col-sm-10">
                                                <Field
                                                    id="upload_url"
                                                    name="upload_url"
                                                    className="form-control"
                                                    placeholder=""
                                                    style={styles.input}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="upload_url"
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Upload Username:
                                            </label>
                                            <div className="col-sm-10">
                                                <Field
                                                    id="upload_username"
                                                    name="upload_username"
                                                    className="form-control"
                                                    placeholder=""
                                                    style={styles.input}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="upload_username"
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Upload Password:
                                            </label>
                                            <div className="col-sm-10">
                                                <Field
                                                    id="upload_password"
                                                    name="upload_password"
                                                    className="form-control"
                                                    placeholder=""
                                                    style={styles.input}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="upload_password"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Schedule:
                                            </label>
                                            <div
                                                className="col-sm-10"
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                }}
                                            >
                                                <TimePicker
                                                    defaultValue={getScheduleDefaultValue(
                                                        initialValues.schedule
                                                    )}
                                                    id="schedule"
                                                    name="schedule"
                                                    placeholder="Select Time"
                                                    style={styles.input}
                                                    className="form-control"
                                                    showSecond={showSecond}
                                                    format={format}
                                                    use12Hours
                                                    onChange={(value) => {
                                                        formik.setFieldValue(
                                                            "schedule",
                                                            cronTime.everyDayAt(
                                                                ...moment(value)
                                                                    .format(
                                                                        "H:mm"
                                                                    )
                                                                    .split(":")
                                                            )
                                                        );
                                                    }}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="schedule"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row align-items-center my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                POS Script:
                                            </label>
                                            <div className="col-sm-10">
                                                <div
                                                    className="custom-file"
                                                    style={{
                                                        height: "calc(1.5em + 1.25rem)",
                                                        width: "70%",
                                                    }}
                                                >
                                                    <input
                                                        className="form-control"
                                                        type="file"
                                                        id="pos_script"
                                                        name="pos_script"
                                                        onChange={(event) => {
                                                            formik.setFieldValue(
                                                                "pos_script",
                                                                event
                                                                    .currentTarget
                                                                    .files[0]
                                                            );
                                                        }}
                                                    />
                                                    {initialValues
                                                        .pos_script_name && (
                                                        <small className="form-text text-muted">
                                                            Current script:{" "}
                                                            {
                                                                initialValues.pos_script_name
                                                            }
                                                        </small>
                                                    )}
                                                    <ErrorMessage
                                                        component="div"
                                                        className="red-text"
                                                        name="pos_script"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row align-items-center my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                POS Type:
                                            </label>
                                            <div className="col-sm-10">
                                                <div>
                                                    <div className="form-check form-check-inline">
                                                        <Field
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="pos_type"
                                                            id="pos_type"
                                                            value="VendHQ"
                                                        />
                                                        <label className="form-check-label">
                                                            VendHQ
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <Field
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="pos_type"
                                                            id="pos_type"
                                                            value="Shopify"
                                                        />
                                                        <label className="form-check-label">
                                                            Shopify
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <Field
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="pos_type"
                                                            id="pos_type"
                                                            value="Others"
                                                        />
                                                        <label className="form-check-label">
                                                            Others
                                                        </label>
                                                    </div>
                                                </div>
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="pos_type"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Notification Email:
                                            </label>
                                            <div className="col-sm-10">
                                                <Field
                                                    id="notification_email"
                                                    name="notification_email"
                                                    type="email"
                                                    className="form-control"
                                                    placeholder=""
                                                    style={styles.input}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="notification_email"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Enable Submission Notification to Email:
                                            </label>
                                            <div className="col-sm-10">
                                                <label className="custom-toggle">
                                                    <Field
                                                        id="is_email_notification_enabled"
                                                        name="is_email_notification_enabled"
                                                        type="checkbox"
                                                    />
                                                    <span className="custom-toggle-slider rounded-circle" />
                                                </label>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                marginTop: "4em",
                                            }}
                                        >
                                            <Button
                                                color="danger"
                                                outline
                                                style={{ marginRight: "4em" }}
                                                onClick={() => {
                                                    setIsOpen(true);
                                                }}
                                            >
                                                Delete Shop
                                            </Button>

                                            <Button
                                                color="default"
                                                type="submit"
                                                style={{
                                                    backgroundColor: "#01497C",
                                                    color: "white",
                                                }}
                                            >
                                                Save Changes
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </CardBody>
                    </Card>
                    <Modal
                        isOpen={isOpen}
                        title="Confirm Delete Shop"
                        description="Do you wish to delete this shop?"
                        handleClose={handleClose}
                        handleConfirm={removeShop}
                    />
                </div>
            )}
        </>
    );
}
